export class DesAccConstants {
    static ACC_SESSION_ID = 'acc-session-id';

    // Catalog
    static ATTACHMENTS = 'attachments';
    static CATALOG_SPACE_ID = 'catalogspace-id';
    static CONTENT_PATH = 'content-path';
    static FILE_PATH = 'file-path';
    static HIDE_ELEMENTS = 'hide-elements';
    static PROVIDER = 'provider';
    static PART_ID = 'part-id';
    static FEATURE_GROUP_ID = 'feature-group-id';
    static SRC = 'src';
    static FILTERSTATUS = 'filter-status';
    static AUTO_SELECT_FIRST = 'auto-select-first';
    static TABLE_NAME = 'tablename'
    static EXPANSION_STATE = 'expansion-state'
    static NAVIGATION_TYPE = 'navigation-type';
    static DISABLE_CAROUSEL = 'disable-carousel'

    // Pagination
    static LIMIT = 'limit';

    // Locale
    static LOCALE = 'locale';

    // display mode value
    static DISPLAY = 'display';
    static REGULAR = 'regular';
    static COMPACT = 'compact';
    static CUSTOM = 'custom';
    static LIST = 'list'

    // Libray
    static LIBRARY_ID = 'library-id';
    static LIBRARY_URN = 'library-urn';
    static LIBRARY_COMPONENTID = 'library-component-id';

    // Team
    static TEAM_ID = 'team-id';

    // Collaboration space
    static COLLABORATION_SPACE_ID = 'collaborationspace-id';

    // Admin
    static SET_STATUS = 'set-status';
    static CATALOG_ID = 'catalog-id';
    static IS_USER_SIEMENSADMIN = 'is-user-siemensadmin';
    static CATALOG_NAME = 'catalog-name';
    static IS_APPROVE_COMMAND = "is-approve-command"

    // Navigation Type
    static CATALOG = 'catalog';
    static STANDARDS = 'standards';
    static CATEGORIES = 'categories';
    static DEFAULT = 'default';
    static FUNC = 'func';
    static STDS = 'stds';
    static MM = "mm";
    static INCH = "inch";

    // Search Filter
    static FILTER_UNIT = 'filter-unit'
    static CONTAINER_ID = 'container-id';
}
